<template>
  <div class="report-container">

    <!-- 主体视界 -->
    <main class="content-main">
      
      <!-- 1. 欢迎语标题（姓名做高级渐变突出） -->
      <section class="welcome-title-group">
        <h1 class="welcome-text">
          Hi ~ <span class="user-name-gradient">{{ ReportData.stuname }}</span> ，<br>
          我们又见面啦 <span class="wave-hand">✨</span>
        </h1>
      </section>

      <!-- 2. 100%保留完整散文文案（错落诗歌排版，拒绝大白框） -->
      <section class="story-body-flow">
        
        <!-- 第一段：时间流逝 -->
        <div class="text-phrase slide-in-1">
          <p class="story-line highlight-time">2026年的旅程已经过半，</p>
          <p class="story-line">在这个急促的世界里，</p>
          <p class="story-line">谢谢你总能静下心来，</p>
          <p class="story-line font-bold-teal">与知识款款同行。</p>
        </div>

        <!-- 第二段：成长蜕变 -->
        <div class="text-phrase pad-left-b slide-in-2">
          <p class="story-line">那些你为成长付出的时光，</p>
          <p class="story-line font-bold-orange">正悄悄变成你身上的光。</p>
          <p class="story-line">翻开这一页，收下属于你的</p>
          <p class="story-line strong-dark">半年度成长答卷。</p>
        </div>

      </section>

      <!-- 3. 底部动态引导组件 -->
      <section class="footer-guide-section fade-in-up">
        <p class="guide-main-text">六月的学习报告已为你生成</p>
        <div class="swipe-hint-box">
          <span class="swipe-finger">👈</span>
          <span class="guide-sub-text">左滑查看更多内容 ~</span>
        </div>
      </section>

    </main>

    <!-- 底部微光朦胧光环装饰 -->
    <!-- <div class="ambient-glow-ball"></div> -->
  </div>
</template>

<script>
export default {
  props: ["ReportData"]
  
}
</script>

<style scoped>
/* 容器背景完美匹配你的亮蓝底色 */
.report-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  padding: 35px 28px;
  background: 
    url("../../assets/26June/logo.png") right top no-repeat,
    url("../../assets/26June/bg.jpg") no-repeat;
  background-size: 100% 100%, cover;
  font-family: -apple-system, "SF Pro Text", "PingFang SC", "Helvetica Neue", sans-serif;
  /* display: flex; */
  /* flex-direction: column; */
}

/* 主体容器弹性分布 */
.content-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 让标题、正文、底部提示拉开空间 */
  padding: 30px 0 10px 0;
  z-index: 2;
}

/* 1. 欢迎标题区 */
.welcome-title-group {
  animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}
.welcome-text {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.5;
  color: #1e293b;
  margin: 0;
  letter-spacing: 0.5px;
}
/* 名字采用高级金橙双色渐变 */
.user-name-gradient {
  background: #e65100;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  font-size: 28px;
}
.wave-hand {
  display: inline-block;
  animation: wave 2.5s ease-in-out infinite;
  transform-origin: 70% 70%;
}

/* 2. 诗歌信笺散文流 */
.story-body-flow {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 30px;
}
.text-phrase {
  position: relative;
}
/* 错落排版：让第二段散文微微右移 16px，营造层次呼吸感 */
.pad-left-b {
  padding-left: 16px;
}
.story-line {
  font-size: 18px;
  line-height: 1.8;
  margin: 0 0 4px 0;
  color: #334155; /* 优雅蓝灰墨色，看得很清楚 */
  letter-spacing: 1px;
}
.story-line:last-child {
  margin-bottom: 0;
}

/* 局部文案情感高亮 */
.highlight-time {
  color: #e65100;
  font-weight: 700;
}
.font-bold-teal {
  color: #03584e;
  font-weight: 700;
}
.font-bold-orange {
  color: #e65100;
  font-weight: 700;
}
.strong-dark {
  color: #0f172a;
  font-weight: 800;
  font-size: 18px;
}

/* 3. 底部滑动提示引导区（彻底告别纯白粗体字的粗糙感） */
.footer-guide-section {
  text-align: center;
  margin-bottom: 10px;
  margin-top: 30px;
}
.guide-main-text {
  font-size: 14.5px;
  color: #475569;
  letter-spacing: 1px;
  margin: 0 0 8px 0;
}
.swipe-hint-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.swipe-finger {
  font-size: 15px;
  animation: nudgeLeft 1.5s ease-in-out infinite;
}
.guide-sub-text {
  font-size: 15px;
  font-weight: 700;
  color: #004d40; /* 采用与顶部呼应的墨绿色 */
  letter-spacing: 0.5px;
}

/* 背景右下角毛玻璃柔光球 */
.ambient-glow-ball {
  position: absolute;
  width: 180px;
  height: 180px;
  right: -40px;
  bottom: 15%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);
  border-radius: 50%;
  z-index: 1;
  pointer-events: none;
}

/* --- 大厂级高级动画定义 --- */
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-15px); }
  to { opacity: 1; transform: translateY(0); }
}
.slide-in-1 { animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) both; }
.slide-in-2 { animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both; }
.fade-in-up { animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.4s both; }

@keyframes fadeInBlur {
  from { opacity: 0; transform: translateY(12px); filter: blur(4px); }
  to { opacity: 1; transform: translateY(0); filter: blur(0); }
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 挥手动画 */
@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  10%, 30% { transform: rotate(-12deg); }
  20%, 40% { transform: rotate(14deg); }
  50% { transform: rotate(0deg); }
}

/* 手指左滑指示动画 */
@keyframes nudgeLeft {
  0%, 100% { transform: translateX(0); opacity: 0.9; }
  50% { transform: translateX(-6px); opacity: 0.4; }
}

/* 手机矮屏幕弹性适配 */
@media screen and (max-height: 670px) {
  .welcome-text { font-size: 22px; }
  .story-body-flow { gap: 20px; }
  .story-line { font-size: 18px; line-height: 1.7; }
  .strong-dark { font-size: 18px; }
  .guide-main-text { font-size: 13px; }
  .guide-sub-text { font-size: 13.5px; }
}

/* --- PC端全屏响应式适配方案 --- */
/* --- PC端全屏响应式适配方案 --- */
@media screen and (min-width: 786px) {
  .report-container {
    width: 100% !important;
    height: 100vh !important;
    padding: 60px 10%; /* 侧边增加安全留白，防止内容贴边 */
    
    /* 单一背景图完美全屏铺满，不留任何死角 */
    background-image: url("../../assets/26June/pcbg.png") !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important; /* 核心：等比例拉伸，宁可裁剪也绝不留白 */
    
    /* 彻底移除手机端的圆角和边界阴影 */
    border-radius: 0 !important;
    box-shadow: none !important;
    border: none !important;
  }

  /* 使主体内容在宽屏中限制宽度并居中，保持诗歌的错落美感，不横向无限拉长 */
  .content-main {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
    padding: 60px 0;
  }

  /* 适度放大 PC 端的字号，让大屏视觉更饱满 */
  .welcome-text {
    font-size: 36px;
  }
  .user-name-gradient {
    font-size: 40px;
  }

  .story-body-flow {
    gap: 48px; /* 增大段落间距 */
  }
  .story-line {
    font-size: 20px; /* 提升散文诗句的字号 */
    line-height: 2;
  }
  .strong-dark {
    font-size: 22px;
  }

  .guide-main-text {
    font-size: 16px;
  }
  .guide-sub-text {
    font-size: 16px;
  }

  /* 调整右下角毛玻璃球在大屏上的视觉比例 */
  .ambient-glow-ball {
    width: 320px;
    height: 320px;
    right: 8%;
    bottom: 12%;
  }
}
</style>